const StepCard = (props) => {
  return (
    <li className="how-step">
      <img src={props.icon} alt={props.title} className="step-icon" />
      <div className="step-number boldTitle ntuna-text-fill">
        <p className="step">{props.step}</p>{" "}
        <p className="right-arrow boldTitle">&rarr;</p>
      </div>
      <h3 className="step-title">{props.title}</h3>
      <p className="step-subtitle">{props.subtitle}</p>
    </li>
  );
};

export default StepCard;
